// import AuthService from '../services/auth.service';
// const user = JSON.parse(localStorage.getItem('user'));
// const token = JSON.parse(localStorage.getItem('access_token'));

// export const auth = {
//   namespaced: true,
//   state: {
//     user: user,
//     isLoggedIn: user ? true : false
//   },

//   actions: {
//     post({ commit }, postData) {
//       // console.log(typeof(postData))
//       return AuthService.post(postData).then(
//         response => {
//           commit('postSuccess');
//           return Promise.resolve(response);
//         },
//         error => {
//           commit('postFailure');
//           return Promise.reject(error.response.data);
//         }
//       );
//     },
    
//     login({ commit }, user) {
//       return AuthService.login(user).then(
//         user => {
//           commit('loginSuccess', user);
//           return Promise.resolve(user);
//         },
//         error => {
//           commit('loginFailure');
//           return Promise.reject(error);
//         }
//       );
//     },

//     logout({ commit }) {
//       return new Promise((resolve, reject) => {
//         AuthService.logout()
//         commit('logout');
//         resolve("Log out successfully!")
//       })
//     },

//     register({ commit }, user) {
//       return AuthService.register(user).then(
//         response => {
//           commit('registerSuccess');
//           return Promise.resolve(response.data);
//         },
//         error => {
//           commit('registerFailure');
//           return Promise.reject(error.response.data);
//         }
//       );
//     }
//   },
//   mutations: {
//     SUBMIT_POST: (state, payload) => state.newPost.push(payload),
//     loginSuccess(state, user) {
//       state.user = user;
//       state.isLoggedIn = true;
//     },

//     loginFailure(state) {
//       state.user = null;
//       state.isLoggedIn = false;
//     },

//     logout(state) {
//       state.user = null;
//       state.isLoggedIn = false;
//     },

//     registerSuccess(state) {
//       state.status = {};
//     },

//     registerFailure(state) {
//       state.status = {};
//     },
//     postSuccess(state) {
//       state.status = {};
//     },
//     postFailure(state) {
//       state.status = {};
//     }
//   },
//   getters: {
//     user: state =>  state.user.user || user.user,
//     token: state =>  state.user.token || user.token
//   }
// };

import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user')) || {};  // Default to empty object if null
const token = localStorage.getItem('access_token') || '';  // Default to empty string if null

export const auth = {
  namespaced: true,
  state: {
    user: user,
    isLoggedIn: !!user  // Use !! to coerce into a boolean
  },

  actions: {
    post({ commit }, postData) {
      return AuthService.post(postData).then(
        response => {
          commit('postSuccess');
          return Promise.resolve(response);
        },
        error => {
          commit('postFailure');
          return Promise.reject(error.response.data);
        }
      );
    },

    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        AuthService.logout();
        commit('logout');
        resolve("Log out successfully!");
      });
    },

    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error.response.data);
        }
      );
    }
  },

  mutations: {
    SUBMIT_POST: (state, payload) => state.newPost.push(payload),

    loginSuccess(state, user) {
      state.user = user;
      state.isLoggedIn = true;
    },

    loginFailure(state) {
      state.user = null;
      state.isLoggedIn = false;
    },

    logout(state) {
      state.user = null;
      state.isLoggedIn = false;
    },

    registerSuccess(state) {
      state.status = {};
    },

    registerFailure(state) {
      state.status = {};
    },

    postSuccess(state) {
      state.status = {};
    },

    postFailure(state) {
      state.status = {};
    }
  },

  getters: {
    // Use optional chaining or check if user exists before accessing properties
    user: state => (state.user && state.user.user) || (user && user.user) || null,
    token: state => (state.user && state.user.token) || token || null
  }
};

